import { combine, guard } from 'effector'
import { $selectedCities } from 'features/city-select/model'

import { $cars } from '../../cars-list/model'
import { $carsCount, $fetchingCarsCount, $routingPanelGate, getCarsCountFx } from './units'

/**
 * Идет ли загрузка числа машин
 */
$fetchingCarsCount.on(getCarsCountFx.pending, (_, pending) => pending)

/**
 * Подписывается на эффект, который вернет массив с числом машин
 */
$carsCount.on(getCarsCountFx.doneData, (_, res) => res)

/**
 * Собираем всё, что нужно запросу и запускаем его, если showCarsCount равняется true, а также мы получили список выбранных городов
 */
const $requestPossible = combine(
  $routingPanelGate.state,
  $cars,

  (routingPanelGate, areCitiesSelected) => {
    const citiesReady = !routingPanelGate.hasCitySelection || !!areCitiesSelected
    return (routingPanelGate.showCarsCount && citiesReady) || routingPanelGate.useBackendFilter
  }
)

guard({
  source: combine({ routingPanel: $routingPanelGate.state, cities: $selectedCities }),
  clock: [$selectedCities, $requestPossible],
  filter: $requestPossible,
  target: getCarsCountFx
})
